import { useEffect, useState } from "react";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { LenisProvider } from "@/lib/LenisProvider";
import { queryClient } from "@/lib/queryClient";
import { Home } from "@/pages/Home";
import { DevtoolsGuard } from "@/components/DevtoolsGuard/DevtoolsGuard";
import { watchDevtools } from "@/lib/watchDevtools";

import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@/theme/global.scss";

setupIonicReact({ mode: "md" });

const applyFreeze = (isOpen: boolean) => {
  document.body.toggleAttribute("data-devtools-freeze", isOpen);
  document.documentElement.style.overflow = isOpen ? "hidden" : "";
};

export const App = () => {
  const [isPeeking, setIsPeeking] = useState(false);

  useEffect(() => {
    const stop = watchDevtools((isOpen) => {
      setIsPeeking(isOpen);
      applyFreeze(isOpen);
    });

    return () => {
      stop();
      applyFreeze(false);
    };
  }, []);

  if (isPeeking) {
    return <DevtoolsGuard />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <LenisProvider>
        <IonApp>
          <IonReactRouter>
            <IonRouterOutlet>
              <Route exact path="/" component={Home} />
            </IonRouterOutlet>
          </IonReactRouter>
        </IonApp>
      </LenisProvider>
    </QueryClientProvider>
  );
};
